import { FETCH_TICKET_DETAIL, FETCH_TICKET_MESSAGES } from "../constants/tickets";
import { Action, TicketState } from "../models/ticket";
import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils";

const initialState: TicketState = {};
function data(state: TicketState = initialState, action: Action): TicketState {
  switch (action.type) {
    case getRequestActionType(FETCH_TICKET_MESSAGES):
      return { ...state, isFetching: true };

    case getSuccessActionType(FETCH_TICKET_MESSAGES):
      return { ...state, data: action.payload, isFetching: false };

    case getFailureActionType(FETCH_TICKET_MESSAGES):
      return { ...state, error: action.payload, isFetching: false };

    case getSuccessActionType(FETCH_TICKET_DETAIL):
      return { ...state, detail: action.payload };

    default:
      return state;
  }
}

export default data;
